export default __webpack_public_path__ + "static/bowlinggreen-723db701752749e8b6a34e130d255077.jpg";